import { create } from 'zustand';

interface WalletType {
  name: string;
  imageUrl?: string;
  value: string;
}

interface WalletStoreType {
  data: WalletType[];
  setData: (values: WalletType[]) => void;
}

const useWalletStore = create<WalletStoreType>((set) => ({
  data: [],
  setData: (values) => set({ data: values }),
}));

export default useWalletStore;
